import { render, staticRenderFns } from "./NotaWindow.vue?vue&type=template&id=4cc80234&"
import script from "./NotaWindow.vue?vue&type=script&lang=js&"
export * from "./NotaWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports